import { EbCommentOnContentPackageMeta, EbCommentOnContentPackagePayload } from 'types/store/EbCommentOnContentPackage';
import { createAsyncReducer } from 'utils/Redux';

import { ebCommentOnContentPackageActions } from '../actions';

export default createAsyncReducer<EbCommentOnContentPackageMeta, EbCommentOnContentPackagePayload>(ebCommentOnContentPackageActions);
